export default {
    create_unsubscribed_contact_title: "Nuevo contacto dado de baja",
    create_unsubscribed_contact_has_been_created: "El contacto dado de baja ha sido creado",
    create_unsubscribed_contact_via: "Via:",
    create_unsubscribed_contact_country_code: "Código del País",
    create_unsubscribed_contact_email: "Correo electrónico",
    create_unsubscribed_contact_phone_number: "Número de teléfono",
    create_unsubscribed_contact_error_create: "No se ha podido crear el contacto dado de baja debido a un error",
    create_unsubscribed_contact_via_email: "Correo",
    create_unsubscribed_contact_via_sms: "SMS",
    create_unsubscribed_contact_email_is_invalid: "Correo electrónico no valido",
    create_unsubscribed_contact_reason: "Razón",
    create_unsubscribed_contact_required_phone: "Por favor inserte un teléfono válido",
}